import { api } from '@/shared/api/client';

export const getCertificateDownload = async (certificateId: string) => {
  const { data } = await api.get<Blob>(
    `/users/me/certificate/${certificateId}/download`,
    {
      responseType: 'blob',
    }
  );

  return data;
};
